import React from "react";

export default function BundleCardForegroundIcon({ ...props }: React.SVGProps<any>) {
  return (
    <svg viewBox="0 0 288 136" height="288" width="136" fill="none" {...props}>
      <line x1="-225.369" y1="63.576" x2="296.161" y2="51.47" stroke="currentColor" />
      <line x1="-225.218" y1="66.414" x2="296.312" y2="54.308" stroke="currentColor" />
      <line x1="-225.067" y1="69.252" x2="296.463" y2="57.146" stroke="currentColor" />
      <line x1="-224.916" y1="72.09" x2="296.615" y2="59.984" stroke="currentColor" />
      <line x1="-224.763" y1="74.928" x2="296.768" y2="62.823" stroke="currentColor" />
      <line x1="-224.611" y1="77.767" x2="296.917" y2="65.661" stroke="currentColor" />
      <line x1="-224.46" y1="80.605" x2="297.069" y2="68.499" stroke="currentColor" />
      <line x1="-224.309" y1="83.443" x2="297.221" y2="71.337" stroke="currentColor" />
      <line x1="-224.156" y1="86.282" x2="297.373" y2="74.176" stroke="currentColor" />
      <line x1="-224.005" y1="89.12" x2="297.524" y2="77.014" stroke="currentColor" />
      <line x1="-223.853" y1="91.958" x2="297.675" y2="79.852" stroke="currentColor" />
      <line x1="-223.702" y1="94.796" x2="297.828" y2="82.69" stroke="currentColor" />
      <line x1="-223.551" y1="97.635" x2="297.979" y2="85.529" stroke="currentColor" />
      <line x1="-223.398" y1="100.472" x2="298.131" y2="88.367" stroke="currentColor" />
      <line x1="-223.247" y1="103.311" x2="298.282" y2="91.205" stroke="currentColor" />
      <line x1="-223.095" y1="106.149" x2="298.435" y2="94.043" stroke="currentColor" />
      <line x1="-222.944" y1="108.988" x2="298.586" y2="96.882" stroke="currentColor" />
      <line x1="-222.793" y1="111.826" x2="298.737" y2="99.72" stroke="currentColor" />
      <line x1="-222.64" y1="114.664" x2="298.889" y2="102.558" stroke="currentColor" />
      <line x1="-222.489" y1="117.502" x2="299.042" y2="105.396" stroke="currentColor" />
      <line x1="-222.337" y1="120.34" x2="299.193" y2="108.234" stroke="currentColor" />
      <line x1="-222.186" y1="123.179" x2="299.344" y2="111.073" stroke="currentColor" />
      <line x1="-222.035" y1="126.017" x2="299.497" y2="113.911" stroke="currentColor" />
      <line x1="-221.882" y1="128.855" x2="299.647" y2="116.749" stroke="currentColor" />
      <line x1="-221.731" y1="131.693" x2="299.798" y2="119.587" stroke="currentColor" />
      <line x1="-221.579" y1="134.532" x2="299.949" y2="122.426" stroke="currentColor" />
      <rect
        x="-42.738"
        y="-45.889"
        width="525.94"
        height="156.652"
        fill="currentColor"
        transform="matrix(0.999991, -0.004189, 0.010848, 0.999963, -183.61673, 0.923316)"
      />
    </svg>
  );
}
